import React from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import { Square } from '@mui/icons-material';

type Props = {
  items: string[];
};

export const BulletList: React.FC<Props> = ({ items }) => {
  return (
    <List>
      {items.map((item, index) => (
        <ListItem key={index} sx={{ py: 0 }}>
          <Square sx={{ fontSize: '6px', color: 'text.primary', mr: 1 }} />
          <ListItemText primary={item} />
        </ListItem>
      ))}
    </List>
  );
};
